import { render, staticRenderFns } from "./supplier-order-summary.vue?vue&type=template&id=2b1df47a&scoped=true"
import script from "./supplier-order-summary.vue?vue&type=script&lang=js"
export * from "./supplier-order-summary.vue?vue&type=script&lang=js"
import style0 from "./supplier-order-summary.vue?vue&type=style&index=0&id=2b1df47a&prod&lang=css"
import style1 from "./supplier-order-summary.vue?vue&type=style&index=1&id=2b1df47a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1df47a",
  null
  
)

export default component.exports